export const GUILD_PIN_MAINTENANCE = false
